
import { formatPostContent } from "@/utils/textFormatting";

interface PostContentProps {
  content: string;
  imageUrl?: string;
  videoUrl?: string;
  postId?: string;
}

export const PostContent = ({ content, imageUrl, videoUrl, postId }: PostContentProps) => {
  return (
    <div className="space-y-4">
      <p className="text-base leading-relaxed whitespace-pre-wrap">
        {formatPostContent(content, postId)}
      </p>
      {imageUrl && (
        <div className="relative w-full rounded-2xl overflow-hidden bg-gray-100 max-h-[600px] shadow-md">
          <img 
            src={imageUrl} 
            alt="Post content" 
            className="w-full h-auto object-contain max-h-[600px]"
            onError={(e) => {
              e.currentTarget.src = "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b";
            }}
          />
        </div>
      )}
      {videoUrl && (
        <div className="relative w-full rounded-2xl overflow-hidden bg-gray-100 aspect-video shadow-md">
          <video 
            src={videoUrl} 
            controls 
            className="w-full h-full"
            preload="metadata"
          >
            <track kind="captions" />
          </video>
        </div>
      )}
    </div>
  );
};
